import cls from "@fvilers/cls";
import { ComponentPropsWithRef, ElementType } from "react";
import styles from "./Dialog.module.css";

type DialogActionsProps<T extends ElementType> = {
  as?: T;
} & ComponentPropsWithRef<T>;

export function DialogActions<T extends ElementType>({
  as,
  className,
  ...props
}: DialogActionsProps<T>) {
  const Comp = as || "div";
  return (
    <Comp
      className={cls(styles.DialogActions, className)}
      data-slot="actions"
      {...props}
    />
  );
}
